import { toggleHeader } from "../include/module";
import { drawFooterCurve } from "../include/module";
import { visibleTop } from "../include/module";
import { anchorAdjust } from "../include/module";
import { anchorLink } from "../include/module";



(() => {

  // let mainImageKasumi = document.getElementById('idx-Main_Box_Image-Kasumi');
  // let mainImageRan    = document.getElementById('idx-Main_Box_Image-Ran');
  // let mainImageAya    = document.getElementById('idx-Main_Box_Image-Aya');
  // let mainImageYukina = document.getElementById('idx-Main_Box_Image-Yukina');
  // let mainImageKokoro = document.getElementById('idx-Main_Box_Image-Kokoro');
  //
  // window.addEventListener('mousemove', (eve) => {
  //   let windowWidth  = window.innerWidth;
  //   let windowHeight = window.innerHeight;
  //   let mouseX = eve.pageX;
  //   let mouseY = eve.pageY;
  //   let windowX = (mouseX * 2 - windowWidth) / windowWidth;
  //   let windowY = (mouseY * 2 - windowHeight) / windowHeight;
  //   mainImageKasumi.style.transform = 'translateX(calc(-50% + ('+  windowX * -2.5 + 'px))) translateY(' + windowY * -2.5 + 'px)';
  //   mainImageRan.style.transform    = 'translateX(calc(-50% + ('+  windowX * -10  + 'px))) translateY(' + windowY * -10  + 'px)';
  //   mainImageAya.style.transform    = 'translateX(calc(-50% + ('+  windowX * -5   + 'px))) translateY(' + windowY * -5   + 'px)';
  //   mainImageYukina.style.transform = 'translateX(calc(-50% + ('+  windowX * -10  + 'px))) translateY(' + windowY * -10  + 'px)';
  //   mainImageKokoro.style.transform = 'translateX(calc(-50% + ('+  windowX * -5   + 'px))) translateY(' + windowY * -5   + 'px)';
  // }, false);

  toggleHeader();

  drawFooterCurve();

  visibleTop();

  anchorAdjust();

  anchorLink();

})();



// WEBPACK FOOTER //
// script.js